import {
  makeVar,
  useReactiveVar
} from '@apollo/client';



export function makeTrigger<T>(args: T) {
  const state = makeVar<T>(args);

  const close = () => {
    state(args);
  };

  const open = (thisArgs: T) => {
    state(thisArgs);
  };

  const useTrigger = () => {
    return useReactiveVar(state);
  };

  return {
    state,
    useTrigger,
    open,
    close
  };
}
